export enum MacStageColor {
    Inception = 'rgb(0, 176, 80)',
    Adoption = 'rgb(251, 59, 21)',
    Proliferation = 'rgb(176, 75, 217)',
    Ubiquity = 'rgb(148, 98, 82)',
}

export enum MacStageBgColor {
	Inception = 'rgb(217, 243, 229)',
	Adoption = 'rgb(254, 226, 220)',
	Proliferation = 'rgb(243, 228, 249)',
	Ubiquity = 'rgb(239, 231, 229)',
}

export enum MacStage {
    NotSelected = 0,
    Inception = 1,
    Adoption = 2,
    Proliferation = 3,
    Ubiquity = 4,
}

export const MAC_STAGE_COLORS = {
	[MacStage.NotSelected]: {
		color: "#7cb5ec",
		bgColor: "#ffffff",
	},
	[MacStage.Inception]: {
		color: MacStageColor.Inception,
		bgColor: MacStageBgColor.Inception,
	},
	[MacStage.Adoption]: {
		color: MacStageColor.Adoption,
		bgColor: MacStageBgColor.Adoption,
	},
	[MacStage.Proliferation]: {
		color: MacStageColor.Proliferation,
		bgColor: MacStageBgColor.Proliferation,
	},
	[MacStage.Ubiquity]: {
		color: MacStageColor.Ubiquity,
		bgColor: MacStageBgColor.Ubiquity,
	},
}
